import * as React from 'react';

import { PageTitleBar } from 'components';

const UserHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { UserHeader };
